

export const apiUrl= 'https://fun-cactus-production.up.railway.app'
/* export const apiUrl= 'http://localhost:4000' */


